import { Spin, message } from 'antd'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import * as api from '@/api/user'
import {useUserInfoContext} from '@/store/userInfo'

const QrLogin = () => {
  const [searchParams] = useSearchParams()
  const navigator = useNavigate()
  const context = useUserInfoContext()

  useEffect(() => {
    api.qrLogin(searchParams.get('code')).then((res) => {
      if(res.status === 'ok') {
        context.updateUserInfo(res)
        const target = searchParams.get('f') || '/'
        navigator(target, {
          replace: true
        })
      } else {
        message.warning(res.errmsg ? res.errmsg : '登录失败');
        navigator('/login', {
          replace: true
        })
      }
    })
  }, [context, searchParams, navigator])

  return (
    <Spin spinning tip='扫码登陆中'>
      <div style={{height: '100vh'}} />
    </Spin>
  )
}

export default QrLogin
